import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";
import { greyMui } from "@ryde/theme";

export const SaveReportContentContainer = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "save-report-content-container",
})`
  padding-top: 16px;
  padding-bottom: 40px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  .created_info {
    font-size: 10px;
    color: ${greyMui._400};
    padding-inline-end: 5px;
  }
  .updated_info {
    font-size: 10px;
    color: ${greyMui._400};
    padding-inline-start: 5px;
  }
`;
export const SaveReportContentContainerFooter = styled.div.attrs<IStyledAttributes>(
  {
    "data-e2e": "save-report-content-container-footer",
  },
)`
  margin-top: 20px;
  display: flex;
`;
